import { Container, Row, Col, Card, Button, ButtonGroup } from 'react-bootstrap';
import React, { useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import DeckManager from 'src/DeckManager';
import ImageModal from 'src/components/ImageModal';
import PrintConfirmationModal from 'src/components/PrintConfirmationModal';

const ShareDeck = () => {
  const navigate = useNavigate();
  const initialStates = {
    deck: [],
  }
  const [modalPrintConfirmationShow, setModalPrintConfirmationShow] = React.useState(false);
  const [modalImageShow, setModalImageShow] = React.useState(false);
  const [modalImageSrc, setModalImageSrc] = React.useState("");

  // Deck to display
  const [deck, setDeck] = React.useState(initialStates.deck);

  const goToMainPage = () => {
    navigate("/");
  }

  // Run on page load
  useEffect(() => {
    const data = new URLSearchParams(window.location.search).get('data');
    if (data){
      let deck = DeckManager.import(data);
      setDeck(deck);
    }
  }, []);

  const CardList = (props) => {
    return(
      <Row className="deck">
        {deck.map(card =>
          card.type === props.type &&
          <Col key={`${card.pack}-${card.id}`} xs={12} sm={12} md={6} lg={3}>
            <Card className="card-list" key={card.pack + " " + card.id}>
              <Row>
                <Col xs={3} sm={3}>
                  <Card.Img
                    src={`images/cards/${card.pack.toLowerCase()}/${card.id}.jpg`} 
                    onClick={() => {
                      setModalImageSrc(`images/cards/${card.pack.toLowerCase()}/${card.id}.jpg`);
                      setModalImageShow(true);
                    }}
                    onError={({ currentTarget }) => {
                      currentTarget.onerror = null; // prevents looping
                      currentTarget.src=`images/cards/unknown.jpg`;
                  }}/>
                </Col>
                <Col className="card-info" xs={9} sm={9}>
                  <Card.Title>[{ card.pack + " " + card.id }] { card.name }</Card.Title>
                  <Card.Text>{ card.qty } ใบ</Card.Text>
                </Col>
              </Row>
            </Card>
          </Col>
        )}
      </Row>
    );
  }

  return (
    <Container fluid className="bg">
      <PrintConfirmationModal
        deck={deck}
        show={modalPrintConfirmationShow}
        onHide={() => setModalPrintConfirmationShow(false)}
      />
      <ImageModal
        show={modalImageShow}
        src={modalImageSrc}
        onClick={() => setModalImageShow(false)}
        onHide={() => setModalImageShow(false)}
      />
      <h1 className="text-center">Deck Manager - ShareDeck</h1>
      <Row>
        <Col xs={12} sm={6}>
          <ButtonGroup className="d-flex">
            <Button variant="secondary" onClick={(event) => goToMainPage()}>กลับไปหน้าหลัก</Button>
          </ButtonGroup>
        </Col>
        <Col xs={12} sm={6}>
          <ButtonGroup className="d-flex">
            <Button variant="success" onClick={(event) => setModalPrintConfirmationShow(true)}>ดาวน์โหลดไฟล์ Decklist</Button>
          </ButtonGroup>
        </Col>
      </Row>
      <hr></hr>
      <Row>
        <Col className='section' xs={12}>
          <h1>ซีล / Seal ({ deck.reduce((acc, {type, qty}) => type === "seal" ? acc + qty : acc, 0) } ใบ)</h1>
        </Col>
      </Row>
      <CardList type="seal"/>
      <Row>
        <Col className='section' xs={12}>
          <h1>มิสติก / Mystic ({ deck.reduce((acc, {type, qty}) => type === "mystic" ? acc + qty : acc, 0) } ใบ)</h1>
        </Col>
      </Row>
      <CardList type="mystic"/>
      <Row>
        <Col className='section' xs={12}>
          <h1>หัวใจ / Master's Heart ({ deck.reduce((acc, {type, qty}) => type === "heart" ? acc + qty : acc, 0) } ใบ)</h1>
        </Col>
      </Row>
      <CardList type="heart"/>
      <Row>
        <Col className='section' xs={12}>
          <h1>รวม Seal+Mystic = [{ deck.reduce((acc, {type, qty}) => type === "seal" || type === "mystic" ? acc + qty : acc, 0) } ใบ]</h1>
        </Col>
      </Row>
    </Container>
  );
}

export default ShareDeck;